import { logoutUser } from "@/store/thunks/studentLogin";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = async () => {
    console.log("Button clicked");
    await dispatch(logoutUser());
    navigate("/");
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen bg-gray-100 text-center">
      <h1 className="text-6xl font-bold text-red-600 drop-shadow-lg mb-6">
        404 - Not Found
      </h1>
      <button
        onClick={logout}
        className="px-6 py-3 bg-[#ec7026] text-white rounded-lg hover:bg-[#d85d1a] transition duration-200 font-medium font-['Semantic/Strong'] shadow-lg"
      >
        Return to Login
      </button>
    </div>
  );
};

export default NotFoundPage;

